import {AbstractControl, UntypedFormControl, ValidatorFn} from '@angular/forms';

/**
 * The Validator for user-detail-form. It implements special
 * validations for all fields of the specific form.
 */
export class DetailViewFormValidator {
  /**
   * @param control The form-control to be validated
   * @returns {{invalidNumberField: boolean}} Return error-key as boolean
   * @description This field should  contain only numbers
   */
  static validateNumberWithoutSpace(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (!input.value.match(/^[0-9]*$/)) {
      return { invalidNumberWithoutSpace: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidNumberField: boolean}} Return error-key as boolean
   * @description This field should  contain only numbers
   */
  static validateNumberWithSpace(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (!input.value.match(/^[0-9 ]*$/)) {
      return { invalidNumberWithSpace: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidNumberField: boolean}} Return error-key as boolean
   * @description This field should  contain only alphabetic withoud spaces
   */
  static validateAlphabeticWithoutSpace(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (!input.value.match(/^[a-zA-Z]*$/)) {
      return { invalidAlphabeticWithoutSpace: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidNumberField: boolean}} Return error-key as boolean
   * @description This field should  contain only alphabetic withoud spaces
   */
  static validateAlphabeticWithSpace(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (!input.value.match(/^[a-zA-Z ]*$/)) {
      return { invalidAlphabeticWithSpace: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidNumberField: boolean}} Return error-key as boolean
   * @description This field should  contain only alphabetic withoud spaces
   */
  static validateAlphaNumericWithoutSpace(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (!input.value.match(/^[a-zA-Z0-9]*$/)) {
      return { invalidAlphaNumericWithoutSpace: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidNumberField: boolean}} Return error-key as boolean
   * @description This field should  contain only alphabetic withoud spaces
   */
  static validateAlphaNumericWithSpace(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (!input.value.match(/^[a-zA-Z0-9 ]*$/)) {
      return { invalidAlphaNumericWithSpace: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidMaxLength200: boolean}} Return error-key as boolean
   * @description Max lenght on this field is 200 letters
   */
  static validateMaxLength200(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (input.value.length > 200) {
      return { invalidMaxLength200: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidMaxLength200: boolean}} Return error-key as boolean
   * @description Max lenght on this field is 100 letters
   */
  static validateMaxLength100(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (input.value.length > 100) {
      return { invalidMaxLength100: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidMaxLength200: boolean}} Return error-key as boolean
   * @description Max lenght on this field is 60 letters
   */
  static validateMaxLength60(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (input.value.length > 60) {
      return { invalidMaxLength60: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidMaxLength10: boolean}} Return error-key as boolean
   * @description Max lenght on this field is 10 letters
   */
  static validateMaxLength10(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (input.value.length > 10) {
      return { invalidMaxLength10: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidMaxLength150: boolean}} Return error-key as boolean
   * @description Max lenght on this field is 150 letters
   */
  static validateMaxLength150(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (input.value.length > 150) {
      return { invalidMaxLength150: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidMaxLength1000: boolean}} Return error-key as boolean
   * @description Max lenght on this field is 1000 letters
   */
  static validateMaxLength1000(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (input.value.length > 1000) {
      return { invalidMaxLength1000: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidMaxLength1000: boolean}} Return error-key as boolean
   * @description Max lenght on this field is 1000 letters
   */
  static validateMinLength4(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (input.value.length < 4) {
      return { invalidMinLength4: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidMaxLength200: boolean}} Return error-key as boolean
   * @description Max lenght on this field is 50 letters
   */
  static validateMaxLength50(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }

    // Wenn bereits angetastet und der Value ist nicht valid, dann werfe
    // ein boolean Error Key als True zurück
    if (input.value.length > 50) {
      return { invalidMaxLength50: true };
    }
  }

  // Max Length 64
  static validateMaxLength64(input: UntypedFormControl): { [s: string]: boolean } {
    if (!input || input.pristine) {
      return;
    }
    if (input.value.length > 64) {
      return { invalidMaxLength64: true };
    }
  }

  // Max Length 32
  static validateMaxLength32(input: UntypedFormControl): { [s: string]: boolean } {
    if (!input || input.pristine) {
      return;
    }
    if (input.value.length > 32) {
      return { invalidMaxLength32: true };
    }
  }

  // Max Length 16
  static validateMaxLength16(input: UntypedFormControl): { [s: string]: boolean } {
    if (!input || input.pristine) {
      return;
    }
    if (input.value.length > 16) {
      return { invalidMaxLength16: true };
    }
  }

  // Max Length 8
  static validateMaxLength08(input: UntypedFormControl): { [s: string]: boolean } {
    if (!input || input.pristine) {
      return;
    }
    if (input.value.length > 8) {
      return { invalidMaxLength08: true };
    }
  }

  // Max Length 4
  static validateMaxLength04(input: UntypedFormControl): { [s: string]: boolean } {
    if (!input || input.pristine) {
      return;
    }
    if (input.value.length > 4) {
      return { invalidMaxLength04: true };
    }
  }

  // Max Length 2
  static validateMaxLength02(input: UntypedFormControl): { [s: string]: boolean } {
    if (!input || input.pristine) {
      return;
    }
    if (input.value.length > 2) {
      return { invalidMaxLength02: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidMaxLength200: boolean}} Return error-key as boolean
   * @description Max lenght on this field is 200 letters
   */
  static validatePLZ(input: UntypedFormControl): { [s: string]: boolean } {
    // Wenn Input FormControl nicht existiert oder noch nicht angetastet wurde
    if (!input || input.pristine) {
      return;
    }
    // Wenn bereits angetastet und der Value ist nich 4 zahlige Nummer, dann werfe
    // ein boolean Error Key als True zurück
    if (!input.value.match(/^[1-9]{1}[0-9]{3}$/)) {
      return { invalidPLZ: true };
    }
  }

  // Year / Jahr
  static validateYear(input: UntypedFormControl): { [s: string]: boolean } {
    if (!input || input.pristine) {
      return;
    }
    // 4 numeric characters long - Numbers - the fisrt can not be a zero
    if (!input.value.match(/^[1-9]{1}[0-9]{3}$/)) {
      return { invalidYear: true };
    }
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidNumberField: boolean}} Return error-key as boolean
   * @description This field should  contain only numbers
   */
  static validateMaxLength(maxLength: number): ValidatorFn {
    return (input: AbstractControl): { [s: string]: boolean } | null => {
      // return if control does not exist or has not changed
      if (!input || input.pristine) {
        return;
      }

      if (input.value.length > maxLength) {
        return {
          invalidMaxLength: true,
        };
      }
    };
  }

  /**
   * @param control The form-control to be validated
   * @returns {{invalidNumberField: boolean}} Return error-key as boolean
   * @description this validates the min. chars of a field
   */
  static validateMinLength(minLenght: number): ValidatorFn {
    return (input: AbstractControl): { [s: string]: boolean } | null => {
      // return if control does not exist or has not changed
      if (!input || input.pristine) {
        return;
      }

      if (input.value.length < minLenght) {
        return { invalidMinLength: true };
      }
    };
  }
}
